(() => {
  const initialise = (root = document) => {
    root.querySelectorAll('[data-gallery]').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      gallery.addEventListener('click', event => {
        const button = event.target.closest('[data-gallery-target]');
        if (!button) return;
        gallery.querySelectorAll('[data-gallery-slide]').forEach(slide => { slide.hidden = slide.id !== button.dataset.galleryTarget; });
        gallery.querySelectorAll('[data-gallery-target]').forEach(item => { item.setAttribute('aria-pressed', String(item === button)); });
      });
    });
    root.querySelectorAll('[data-quantity]').forEach(control => {
      if (control.dataset.ready) return;
      control.dataset.ready = 'true';
      const input = control.querySelector('input');
      control.addEventListener('click', event => {
        const button = event.target.closest('[data-quantity-step]');
        if (!button || !input) return;
        const min = Number(input.min || 1);
        const max = input.max ? Number(input.max) : Infinity;
        const next = Math.min(max, Math.max(min, Number(input.value || min) + Number(button.dataset.quantityStep)));
        input.value = String(next);
        input.dispatchEvent(new Event('change', {bubbles: true}));
      });
    });
    root.querySelectorAll('[data-variant-select]').forEach(select => {
      if (select.dataset.ready) return;
      select.dataset.ready = 'true';
      select.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', select.value);
        window.location.assign(url.href);
      });
    });
    root.querySelectorAll('[data-search-form]').forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      const input = form.querySelector('input[name="q"]');
      const clear = form.querySelector('[data-search-clear]');
      const sync = () => { if(clear) clear.hidden = !input.value; };
      input.addEventListener('input', sync);
      clear?.addEventListener('click', () => { input.value = ''; sync(); input.focus(); });
      sync();
    });
    root.querySelectorAll('[data-product-form]').forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      form.addEventListener('submit', event => {
        const quantity = form.querySelector('input[name="quantity"]');
        const error = form.querySelector('[data-form-error]');
        if (quantity && (!Number.isInteger(Number(quantity.value)) || Number(quantity.value) < 1)) {
          event.preventDefault();
          quantity.setAttribute('aria-invalid','true');
          if(error) error.hidden = false;
          quantity.focus();
          return;
        }
        if (form.dataset.submitting) { event.preventDefault(); return; }
        form.dataset.submitting = 'true';
        form.querySelectorAll('button[type="submit"]').forEach(button => { button.disabled = true; button.setAttribute('aria-busy','true'); });
      });
    });
  };
  initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('[data-product-form][data-submitting]').forEach(form => {
      delete form.dataset.submitting;
      form.querySelectorAll('button[aria-busy="true"]').forEach(button => { button.disabled = false; button.removeAttribute('aria-busy'); });
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.mobile-menu[open]').forEach(menu => { menu.open = false; menu.querySelector('summary').focus(); });
  });
})();
